module.exports = __webpack_public_path__ + "static/media/ganador.57248c1e.jpeg";